"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VWOAnalyticsService = void 0;
exports.VWOAnalyticsService = {
    dispatchVWOEvent: (eventName, properties) => {
        window.VWO = window.VWO || [];
        window.VWO.event =
            window.VWO.event ||
                function () {
                    // eslint-disable-next-line prefer-rest-params
                    window.VWO.push(['event'].concat([].slice.call(arguments)));
                };
        window.VWO.event(eventName, properties);
    },
};
